import styled from 'styled-components';

import { Color, FontWeight } from '../../enums';
import { StyledComponent } from '../../interfaces';

export const Container: StyledComponent<'div'> = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Header: StyledComponent<'h2'> = styled.h2`
  font-weight: ${FontWeight.Medium};
  font-size: 22px;
  line-height: 28px;
  letter-spacing: -0.01em;
  color: ${Color.Black};
`;

export const ArrowButton: StyledComponent<'button'> = styled.button.attrs({ type: 'button' })`
  padding-left: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const Button: StyledComponent<'button'> = styled.button.attrs({ type: 'button' })`
  color: ${Color.Gray500};
  font-weight: ${FontWeight.Medium};
  font-size: 16px;
  line-height: 26px;
  text-decoration: underline;
  transition: 0.3s;

  &:hover {
    color: ${Color.Black};
  }
`;
